import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { RaceSummaryRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummaryNew.style';
import {
    CellRunner,
    JockeyAndTrainerDetailsBox,
    SilkCastWrapper,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/horseRacing/RaceSummaryCastRowHorseRacing.style';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    anyCast?: React.ReactNode;
    className?: string;
    dataTest?: string;
    isNonRunner?: boolean;
    isUnnamedFavourite: boolean;
    oneCast?: React.ReactNode;
    selectionId: SelectionId;
    threeCast?: React.ReactNode;
    twoCast?: React.ReactNode;
}

export const RaceSummaryCastRowHorseRacing = observer('RaceSummaryCastRowHorseRacing', (props: PropsType) => {
    const { anyCast, className, dataTest, isNonRunner, isUnnamedFavourite, oneCast, selectionId, threeCast, twoCast } =
        props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    if (isUnnamedFavourite === true) {
        return null;
    }

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const isDetailsAvailable = selectionModel.templateId !== 'unnamed-favourite';

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    const silkUrl = selectionModel.metaDataSilkUrl ?? '';
    const silkAltDesc = selectionModel.metaDataSilk ?? 'Silk image';

    return (
        <RaceSummaryRow
            className={className}
            isNonRunner={isNonRunner}
            data-test={dataTest}
            variant={configState.componentVariants.sportsbookVariant}
        >
            <CellRunner>
                <SilkCastWrapper>
                    <LazyImageSilk
                        imgBase={{
                            src: silkUrl,
                            optimizeOptions: {
                                quality: 85,
                                width: 54,
                            },
                        }}
                        alt={silkAltDesc}
                    />
                </SilkCastWrapper>

                <JockeyAndTrainerDetailsBox
                    isDetailsAvailable={isDetailsAvailable}
                    selectionId={selectionId}
                />
            </CellRunner>
            {oneCast}
            {twoCast}
            {marketModel.tricastsOffered && threeCast}
            {anyCast}
        </RaceSummaryRow>
    );
});
